
import { mapGetters, mapActions } from 'vuex';
import AuthorGrade from '@/enums/AuthorGrade';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';
import AppReviewUserInfoSectionUserDisplay from './AppReviewUserInfoSection/AppReviewUserInfoSectionUserDisplay.vue';

export default {
  name: 'AppReviewUserInfoSectionListV3',
  components: {
    AppReviewUserInfoSectionUserDisplay
  },
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('reviewSettings', [
      'isAuthorDisplayTypeUserGrade',
      'isAuthorDisplayTypeAuthorType'
    ]),
    ...mapGetters('review', ['showDate', 'showEditOrDelete']),
    DropdownMenuWidth: () => DropdownMenuWidth,
    editOrDeleteOptions() {
      return [
        this.review.editable
          ? { name: this.$t('app.edit_review'), value: 'edit' }
          : null,
        this.review.deletable
          ? {
              name: this.$t('app.delete_review'),
              value: 'delete',
              danger: true
            }
          : null
      ].filter(v => v);
    },
    userOption() {
      if (this.isAuthorDisplayTypeUserGrade && this.review.brand_user_grade) {
        return {
          name: this.$t('user_grade'),
          value: this.review.brand_user_grade.name
        };
      }

      if (this.isAuthorDisplayTypeAuthorType && this.review.brand_author_type) {
        return {
          name: this.$t('author_grade'),
          value: this.review.brand_author_type.title
        };
      }

      if (this.isAuthorDisplayTypeAuthorType && this.review.author_grade) {
        return {
          name: this.$t('author_grade'),
          value: AuthorGrade.t(this.review.author_grade)
        };
      }

      return null;
    },
    reviewAndUserOptions() {
      const options = [...(this.review.customer_properties || [])];
      if (this.userOption) options.push(this.userOption);
      return options.map(o => `${o.name} ${o.value}`).join(' ・ ');
    },
    showReviewAndUserOptions() {
      return (
        (!!this.review.customer_properties &&
          this.review.customer_properties.length > 0) ||
        !!this.userOption
      );
    }
  },
  methods: {
    ...mapActions('review', ['handleEditOrDeleteReview'])
  }
};
